import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { StoreTabEnum } from '../enum/store-tab-enum';
import { SettingsIcon } from '@systemeio/ui/icons';
const StoreEditButton: FC = () => {
  const $ = _c(11);
  const {
    storeId
  } = useStoreQuery();
  const {
    data: store
  } = useStore(storeId);
  const {
    onChangeTab
  } = useStoreQuery();
  const {
    t
  } = useLocoTranslation();
  const t0 = !store;
  let t1;
  if ($[0] !== onChangeTab) {
    t1 = () => onChangeTab(StoreTabEnum.storeSettings);
    $[0] = onChangeTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SettingsIcon className="fill-background-secondary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("global.settings");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="hidden sm:inline">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t4) {
    t5 = <><PrimaryButton disabled={t0} onClick={t1}>{t2}{t4}</PrimaryButton></>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default StoreEditButton;